import React, { createContext, useContext } from 'react';

/**
 * EmbedContext
 *
 * Signals that the current route is being rendered inside another iframe
 * (e.g. the Immersive Content Player) and should suppress the platform
 * shell (sidebar, top header, org switcher, notifications, slide-out menu).
 *
 * Default value: `false` — every existing route renders normally.
 * To opt a route into bare embed mode, wrap it in <EmbedShell>:
 *
 *   <Route path="/embed/..." element={<EmbedShell><MyPage /></EmbedShell>} />
 *
 * Layout components (MainLayout) check this context and
 * return a minimal bare wrapper instead of their full chrome.
 */
const EmbedContext = createContext(false);

export const useEmbedMode = () => useContext(EmbedContext);

export function EmbedShell({ children }) {
  return (
    <EmbedContext.Provider value={true}>
      {children}
    </EmbedContext.Provider>
  );
}

export default EmbedContext;
